import React from 'react'
import spinner from "./images/spinner.gif"
function Spinner() {
    return (
        <img className="spinner" src={spinner} alt="loading" />
    )
}

export default Spinner
